import { useMutation } from '@tanstack/react-query';
import { IVerifyOtpBody } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const verifyOtp = async (body: IVerifyOtpBody) => {
  const res = await apiManager.post("/auth/admin/verify", body);
  return res;
};

export const useVerifyOtp = () =>
  useMutation({
    mutationFn: async (body: IVerifyOtpBody) => {
      const res = await apiClient.post(ENDPOINTS.AUTH.VERIFY_OTP, body);
      return res.data;
    },
  });
